<div class="message">
  @if (icon) {
    <rask-icon icon="{{icon}}"></rask-icon>
  }
  <span>{{message}}</span>
</div>
